import React, { ReactNode } from "react";
import DownloadButton from "./DownloadButton";

interface TableContainerProps {
  children: ReactNode;
  onDownload: () => void;
  title?: string;
  isRCA?: boolean;
  className?: string;
}

const TableContainer: React.FC<TableContainerProps> = ({
  children,
  onDownload,
  title,
  isRCA = false,
  className = "",
}) => {
  return (
    <div
      className={`bg-ternary-bg text-white p-6 pb-10 rounded-lg shadow-lg ${className}`}
    >
      <div className="flex justify-between items-center mb-4">
        <div className="flex-1">
          {title && (
            <h2 className="text-lg font-semibold text-white">{title}</h2>
          )}
        </div>
        <div>{isRCA ? <></> : <DownloadButton onClick={onDownload} />}</div>
      </div>
      {children}
    </div>
  );
};

export default TableContainer;
